import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {ExtendedFormBuilder} from '@aviary/forms/extensions/extended-form-builder/extended-form-builder';
import {TextareaFormFieldComponent} from '@aviary/forms/fields/textarea-form-field/textarea-form-field.component';

@Component({
  selector: 'mx-component-lib-textarea-form-fields',
  host: {
    class: 'component-lib-content flex flex-col w-3/4 gap-1'
  },
  templateUrl: './component-lib-textarea-form-fields.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TextareaFormFieldComponent]
})
export class ComponentLibTextareaFormFieldsComponent {
  private readonly formBuilder: ExtendedFormBuilder = inject(ExtendedFormBuilder);

  public readonly shortExistingText = 'This is a short amount of text to render in a component that might have some';
  public readonly longExistingText =
    `Lorem ipsum Quisque id eros sit amet metus lacinia pellentesque vitae sit amet lectus. ` +
    `Sed venenatis, lorem vitae semper condimentum, diam mauris vulputate magna, at ultricies magna leo eu justo. ` +
    `Morbi sed lacinia eros. Phasellus eget sem nulla. Donec egestas eget turpis sed sodales. ` +
    `Nullam tempus felis sit amet nisi lobortis, in venenatis lorem condimentum. ` +
    `Donec non lorem eleifend, hendrerit metus ut, vulputate elit. Suspendisse luctus sagittis pulvinar.\n\n` +
    `Phasellus id metus vel leo accumsan varius nec in nisl. Donec faucibus ultrices quam, at accumsan turpis fermentum nec. ` +
    `Nam mauris sem, dictum euismod nunc eu, facilisis eleifend urna. Mauris dapibus sem metus, eget scelerisque tortor accumsan in. ` +
    `Fusce ligula ante, iaculis non lorem sit amet, lobortis bibendum tortor. Phasellus libero massa, sodales in aliquam eget, dictum vitae tellus. ` +
    `Nam eros diam, ornare et pulvinar pretium, suscipit ac nisl. Maecenas eget sapien quis est finibus elementum. ` +
    `Nunc nec urna tincidunt, finibus felis ut, facilisis nibh. Morbi laoreet convallis magna, sit amet auctor risus viverra commodo. ` +
    `Duis ac ex sed massa consequat dapibus et vitae enim.`;

  public readonly textFormGroup: ExtendedFormGroup = this.formBuilder.nonNullable.extendedGroup({
    messageEmpty: ['', []],
    messageShort: [`${this.shortExistingText}. Default 4 line, scroll on overflow`, []],
    messageReadOnly: [`***READ ONLY*** ${this.shortExistingText}`, []],
    messageShortGrow: [`${this.shortExistingText}. Autosize to grow past 4 rows, default max autosize rows 6 (then scroll)`, []],
    messageLongClipped: [this.longExistingText, []],
    messageLongFull: [this.longExistingText, []]
  });
}